import jsonData from "../../assets/JSONS/ecographStruct.json"

export const getEstructuras = () => {
  return jsonData.subestructuras.map((estructura) => ({
    value: estructura.nombre,
    label: estructura.nombre,
  }))
}

export const getSubestructuras = (estructuraNombre) => {
  const estructura = jsonData.subestructuras.find((e) => e.nombre === estructuraNombre)
  return estructura && estructura.subestructuras
    ? estructura.subestructuras.map((sub) => ({ value: sub.nombre, label: sub.nombre }))
    : []
}

export const tieneSubestructuras = (estructuraNombre) => {
  const estructura = jsonData.subestructuras.find((e) => e.nombre === estructuraNombre)
  return estructura && estructura.subestructuras && estructura.subestructuras.length > 0
}

export const getIncidencias = (estructuraNombre, subestructuraNombre) => {
  const estructura = jsonData.subestructuras.find((e) => e.nombre === estructuraNombre)

  if (!estructura) return []

  if (estructura.nombre === subestructuraNombre) {
    // Si no tiene subestructuras o estamos buscando incidencias de la estructura principal
    return estructura.incidencias
      ? estructura.incidencias.map((inc) => ({
          value: inc.nombre,
          label: inc.nombre,
        }))
      : []
  }

  // Buscar en subestructuras
  const subestructura = estructura.subestructuras?.find((sub) => sub.nombre === subestructuraNombre)
  return subestructura && subestructura.incidencias
    ? subestructura.incidencias.map((inc) => ({
        value: inc.nombre,
        label: inc.nombre,
      }))
    : []
}

export const getRedaccion = (estructuraNombre, subestructuraNombre, incidenciaNombre) => {
  const estructura = jsonData.subestructuras.find((e) => e.nombre === estructuraNombre)
  if (!estructura) return ""

  if (estructura.nombre === subestructuraNombre) {
    // Si no tiene subestructuras o estamos buscando la redacción de la estructura principal
    const incidencia = estructura.incidencias?.find((inc) => inc.nombre === incidenciaNombre)
    return incidencia?.redaccion || `${estructura.nombre}, incidencia ${incidenciaNombre}`
  }

  // Buscar en subestructuras
  const subestructura = estructura.subestructuras?.find((sub) => sub.nombre === subestructuraNombre)
  if (!subestructura) return ""

  const incidencia = subestructura.incidencias?.find((inc) => inc.nombre === incidenciaNombre)
  return incidencia?.redaccion || `${estructura.nombre}, ${subestructura.nombre}, incidencia ${incidenciaNombre}`
}

